import assetClassCreatedProjections from './projection/asset-class-created.projection';
import assetClassDeletedProjections from './projection/asset-class-deleted.projection';
import assetClassNameSetProjections from './projection/asset-class-name-set.projection';
import assetsImportedProjections from './projection/assets-imported.projection';
import assetsPurgedProjections from './projection/assets-purged.projection';
import assetClassPutProjections from './projection/asset-class-put.projection';
const projections = {
    ...assetClassCreatedProjections,
    ...assetClassDeletedProjections,
    ...assetClassNameSetProjections,
    ...assetsImportedProjections,
    ...assetsPurgedProjections,
    ...assetClassPutProjections,
};
export default projections;
//# sourceMappingURL=projections-index.js.map